import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesWarehouseEditMain } from './modules/ui/Main';

const WarehouseEditPage = (
  <SuspensePage>
    <PagesWarehouseEditMain />
  </SuspensePage>
);

export default WarehouseEditPage;
